import script from "./Connected.vue?vue&type=script&setup=true&lang=js"
export * from "./Connected.vue?vue&type=script&setup=true&lang=js"

import "./Connected.vue?vue&type=style&index=0&id=e0f3cd38&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0f3cd38"]])

export default __exports__